import { useNavigate } from 'react-router-dom';
import { ISO_MESSAGES } from '@/data/iso20022';
import { messageWorkspaceHref } from '@/lib/messageWorkspace';
import { useT } from '@/i18n';

const AREAS = ['pain', 'pacs', 'camt', 'acmt'] as const;

export function MessagePicker({ short }: { short: string }) {
  const t = useT();
  const navigate = useNavigate();

  function onChange(next: string) {
    navigate(messageWorkspaceHref(next, { mode: 'edit' }));
  }

  return (
    <label className="flex min-w-0 flex-col gap-1">
      <span className="eyebrow">{t('try.messageType')}</span>
      <select
        value={short}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-rule bg-surface px-2 py-1.5 font-mono text-[13px] hover:border-ink"
      >
        {AREAS.map((area) => (
          <optgroup key={area} label={t(`area.${area}`)}>
            {ISO_MESSAGES.filter((m) => m.area === area).map((m) => (
              <option key={m.short} value={m.short}>
                {m.short} — {m.rootElement}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </label>
  );
}
